import { useState } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

// import MyButton from "../../Components/MyButton";
// import Can from "../../Components/Can";

function CashTransfer() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    from: "",
    to: "",
    value: "",
    date: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const [selectedTransfer, setSelectedTransfer] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const handleAdd = () => {
    setFormData({
      from: "",
      to: "",
      value: "",
      date: "",
    });
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      const payload = {
        ...formData,
        date: formData.date || new Date().toISOString().split("T")[0],
      };

      await API.post("/cash-transfer", payload);
      toast.success("تم إضافة التحويل النقدي بنجاح");
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        toast.error("حدث خطأ أثناء العملية");
      }
    } finally {
      setLoading(false);
    }
  };
  const handleShowDetails = (withdrawl) => {
    setSelectedTransfer(withdrawl);
    setShowDetailsModal(true);
  };

  const columns = [
    { header: "من", accessor: (row) => (row.from === "bank" ? "بنك" : "كاش") },
    { header: "إلى", accessor: (row) => (row.to === "bank" ? "بنك" : "كاش") },
    { header: "القيمة", accessor: "value" },
    { header: "التاريخ", accessor: "date" },
    {
      header: "الإجراءات",
      accessor: (row) => (
        <button
          className="btn btn-sm mx-1 extrabtn"
          title="عرض التفاصيل"
          onClick={() => handleShowDetails(row)}>
          <FontAwesomeIcon icon={faEye} color="white" />
        </button>
      ),
      hideOnPrint: true,
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title="تحويلات نقدية" />
      {/* <Can permission="cash_transfer_create">
                <MyButton
                    text="إضافة تحويل"
                    variant="success"
                    type="button"
                    className="mb-3"
                    onClick={handleAdd}
                />
            </Can> */}
      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title="إضافة تحويل نقدي"
        onSubmit={handleSubmit}
        loading={loading}
        mode="form">
        <MyInput
          as="select"
          value={formData.from}
          onChange={(e) => setFormData({ ...formData, from: e.target.value })}
          options={[
            { value: "", label: "من" },
            { value: "cash", label: "خزنة" },
            { value: "bank", label: "بنك" },
          ]}
          error={errors.from?.[0]}
        />

        <MyInput
          as="select"
          value={formData.to}
          onChange={(e) => setFormData({ ...formData, to: e.target.value })}
          options={[
            { value: "", label: "الي" },
            { value: "cash", label: "خزنة" },
            { value: "bank", label: "بنك" },
          ]}
          error={errors.to?.[0]}
        />

        <MyInput
          label="القيمة"
          type="number"
          value={formData.value}
          onChange={(e) => setFormData({ ...formData, value: e.target.value })}
          error={errors.value?.[0]}
        />

        <MyInput
          label="التاريخ"
          type="date"
          value={formData.date}
          onChange={(e) => setFormData({ ...formData, date: e.target.value })}
          error={errors.date?.[0]}
        />
      </ModalForm>
      <ModalForm
        show={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title="تفاصيل التحويل النقدي"
        mode="print">
        {selectedTransfer ? (
          <div dir="rtl">
            <h5 className="text-center mb-5 ">
              نحويلات نقدية ({selectedTransfer.id})
            </h5>
            <p>
              <strong>من:</strong>{" "}
              {selectedTransfer.from === "bank" ? "بنك" : "خزنة"}
            </p>
            <p>
              <strong>إلى:</strong>{" "}
              {selectedTransfer.to === "bank" ? "بنك" : "خزنة"}
            </p>
            <p>
              <strong>القيمة:</strong> {selectedTransfer.value}
            </p>
            {/* <p>
              <strong>التاريخ:</strong>{" "}
              {selectedTransfer.date
                ? new Date(selectedTransfer.date).toLocaleDateString("ar-EG")
                : "—"}
            </p> */}
            <p>
              <strong>ناريخ الحدث:</strong>{" "}
              {selectedTransfer.created_at
                ? new Date(selectedTransfer.created_at).toLocaleString(
                    "ar-EG",
                    {
                      dateStyle: "short",
                      timeStyle: "short",
                    }
                  )
                : "—"}
            </p>
          </div>
        ) : (
          <p>جاري التحميل...</p>
        )}
      </ModalForm>

      <MyTable
        resource="cash-transfer"
        columns={columns}
        refreshKey={refreshKey}
        title={"تحويلات نقدية"}
        dateFilter={{ field: "created_at", label: "تاريخ الإنشاء" }}
        button={{
          text: "إضافة تحويل",
          onClick: handleAdd,
          variant: "success",
          permission: "cash_transfer_create",
        }}
      />

      <div
        style={{
          position: "relative",
          bottom: "20px", // مسافة بسيطة من تحت
          left: "50%",
          transform: "translateX(-50%)", // يخلّي العنصر في وسط الشاشة بالظبط
          zIndex: 1000,
          marginTop: "40px",
          width: "fit-content",
        }}>
        <div
          className="text-center"
          style={{
            borderRadius: "15px",
            padding: "12px 35px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            minWidth: "300px",
            maxWidth: "90vw",
            backgroundColor: "#b19bd5",
            color: "#fff",
          }}>
          <strong>تنبيه:</strong> عند إجراء تحويل نقدي فإنك{" "}
          <u>لن تتمكن من الحذف أو التعديل</u>.
        </div>
      </div>
    </div>
  );
}

export default CashTransfer;
